<script lang="ts">
  type Capability = { key: string; label: string };
  type Group = { resource: string; label: string; capabilities: Capability[] };

  export let groups: Group[] = [];
  export let selectedKeys: string[] = [];
  export let inputName: string;

  const idFor = (key: string) => `permission-${key.replace(":", "-")}`;
  const groupKeys = (group: Group) => group.capabilities.map((capability) => capability.key);
  const countSelected = (group: Group, selected: string[]) =>
    groupKeys(group).filter((key) => selected.includes(key)).length;

  function toggleGroup(group: Group) {
    const keys = groupKeys(group);
    if (countSelected(group, selectedKeys) === keys.length) {
      selectedKeys = selectedKeys.filter((key) => !keys.includes(key));
    } else {
      selectedKeys = [...new Set([...selectedKeys, ...keys])];
    }
  }
</script>

<div class="row g-3 mb-3">
  {#each groups as group (group.resource)}
    <div class="col-sm-6 col-md-4 col-lg-3">
      <fieldset class="card h-100" id={`permission-card-${group.resource}`}>
        <legend class="visually-hidden">{group.label}</legend>
        <div class="card-header d-flex align-items-center justify-content-between py-2">
          <span class="fw-semibold">{group.label}</span>
          <span class="d-inline-flex align-items-center small text-muted">
            <label class="form-check-label me-2" for={`permission-group-${group.resource}`}>All</label>
            <input
              class="form-check-input mt-0"
              type="checkbox"
              id={`permission-group-${group.resource}`}
              checked={countSelected(group, selectedKeys) === group.capabilities.length}
              indeterminate={countSelected(group, selectedKeys) > 0 &&
                countSelected(group, selectedKeys) < group.capabilities.length}
              on:change={() => toggleGroup(group)}
            />
          </span>
        </div>
        <div class="card-body py-2">
          {#each group.capabilities as capability (capability.key)}
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id={idFor(capability.key)}
                name={inputName}
                value={capability.key}
                bind:group={selectedKeys}
              />
              <label class="form-check-label" for={idFor(capability.key)}>
                {capability.label}
              </label>
            </div>
          {/each}
        </div>
      </fieldset>
    </div>
  {/each}
</div>

<p class="mb-3">
  This role grants exactly
  <strong>{selectedKeys.length}</strong>
  {selectedKeys.length === 1 ? "permission" : "permissions"}.
</p>
